/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M19.864 3.587a.375.375 0 0 0-.384-.058L2.23 10.653a.375.375 0 0 0 .008.695l4.748 1.844c.117.046.249.03.351-.042l6.3-4.48a.375.375 0 0 1 .477.576l-5.25 5.059a.375.375 0 0 0-.114.27v5.049a.375.375 0 0 0 .698.189l2.375-4.068a.188.188 0 0 1 .253-.07l4.37 2.4a.375.375 0 0 0 .547-.25l3-13.873a.381.381 0 0 0-.13-.365Z"
})), "0 0 24 24", "Send");